import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { api } from "../lib/api";
import { LogoMark } from "../components/Logo";

const AuthContext = createContext(null);

export const AuthProvider = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <Outlet />
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const FullScreenLoader = () => (
  <div data-testid="page-loading" className="flex min-h-screen items-center justify-center bg-[#0B192C]">
    <LogoMark className="h-14 w-14 animate-pulse" />
  </div>
);

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
